export enum ArrangementFilterTypeOptions {
  ALL_ARRANGEMENTS = 'AllArrangements',
  REGULAR_ARRANGEMENTS = 'RegularArrangement',
  TRIGGER_ARRANGEMENTS = 'TriggerArrangement',
}

export default ArrangementFilterTypeOptions;
